import React, { memo, useMemo, useState } from 'react';

import { FilterGroup } from '@/components/Filter/types';
import { Filter } from '@/components/FilterManager';

import useTagOptions from '../../../hooks/useTagOptions';
import { SingleSelectValue } from '../../../types';
import { TagsValueSelectorProps } from '../types';

function SingleSelectComp(
  props: TagsValueSelectorProps & {
    toggle: () => void;
  },
) {
  const { tag, selectedTagValue, onChange, children, filters, toggle } = props;
  const { id } = tag;
  const [searchText, setSearchText] = useState('');
  const {
    error: tagOptionFetchingError,
    tagOptions,
    fetchMore,
    fetching,
    isFetchingMore,
  } = useTagOptions({
    tagId: id,
    parentId: filters?.parentId,
    valueText: searchText,
    valueIds: filters?.valueIds,
  });
  const singleSelectTagValue = selectedTagValue as SingleSelectValue;

  const selectedValues = singleSelectTagValue || [];

  const groups: FilterGroup[] = useMemo(() => {
    if (filters?.valueIds && filters?.valueIds.length === 0) {
      return [];
    }

    return tagOptions?.length
      ? [
          {
            id: tag.id,
            options: tagOptions?.map((option) => ({
              value: option.id,
              label: option.name,
            })),
          },
        ]
      : [];
  }, [filters?.valueIds, tagOptions, tag.id]);

  return (
    <Filter
      isSingleSelect
      open
      asyncOptions={{
        search: {
          value: searchText,
          onChange: setSearchText,
        },
        fetchMore,
        fetching: fetching || isFetchingMore,
        error: !!tagOptionFetchingError,
      }}
      groups={groups}
      showActionButtons={false}
      value={selectedValues}
      onChange={onChange}
      onToggle={toggle}>
      {children}
    </Filter>
  );
}

export default memo(SingleSelectComp);
